import React from 'react';
import PropTypes from "prop-types";

const TabTitle = ({
    isActive,
    text = "",
    className = "",
    onClick = () => {},
    tabTitleTextAlignment = 'left'
}) => {
    return (
        <span className={"tab-title " + (isActive ? "active" : "")} onClick={onClick}>
            <span>{text}</span>
        </span>
    );
};

TabTitle.propTypes = {
    isActive: PropTypes.bool.isRequired,
    text: PropTypes.string,
    tabTitleTextAlignment: PropTypes.string,
    className: PropTypes.string,
    bgColorClass: PropTypes.string,
    onClick: PropTypes.func
};

export default TabTitle;